module.exports = __webpack_public_path__ + "img/ring_g_0_1_0@2x.b5ef5a5b.png";